import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

const LIST_FIELDS = ["highlights", "whats_inside", "keywords"];
const TEXT_FIELDS = [
  ["short_description", "Short description", 2],
  ["long_description", "Long description", 6],
  ["ideal_for", "Ideal for", 2],
  ["seo_title", "SEO title", 1],
  ["seo_description", "SEO description", 2],
];

export const StoreListingTab = ({ p, set }) => {
  const [busy, setBusy] = useState(false);
  const listing = p.listing || {};
  const setL = (k, v) => set({ listing: { ...listing, [k]: v } });

  const generate = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/products/${p.id}/listing/generate`);
      set({ listing: r.data });
      toast.success("Listing copy written — remember to save");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="store-listing-tab">
      <div className="bg-[#FFFDF9] border border-[#2A2325]/10 p-6 space-y-3" data-testid="listing-price-card">
        <div className="eyebrow">Price on softspinepress.com</div>
        <div className="flex items-center gap-3">
          <div className="flex items-center border border-input bg-white h-10 w-44">
            <span className="px-3 text-sm text-[#5C5255] border-r border-input h-full flex items-center">A$</span>
            <input inputMode="decimal" value={p.price || ""} onChange={(e) => set({ price: e.target.value.replace(/[^0-9.]/g, "") })} placeholder="9.99" className="flex-1 min-w-0 px-3 text-sm outline-none bg-transparent" data-testid="listing-price-input" />
          </div>
          <span className="text-sm text-[#5C5255]">AUD, including GST if you charge it</span>
        </div>
        {p.price && !/^\d{1,5}(\.\d{1,2})?$/.test(p.price) && <p className="text-xs text-[#9B2C2C]" data-testid="listing-price-error">Enter an amount like 9.99</p>}
        <p className="text-xs text-[#5C5255]">Customers pay on softspinepress.com; this app never takes payments. The price is sent to your store when you publish or press “Update PDF & details on the store”.</p>
      </div>
      <div className="bg-[#FFFDF9] border border-[#2A2325]/10 p-6 space-y-4">
        <div className="flex items-center justify-between">
          <div className="eyebrow">Store listing copy (goes into Listing JSON)</div>
          <Button size="sm" onClick={generate} disabled={busy} className="rounded-none gap-1.5" data-testid="generate-listing-btn"><Sparkles size={14} /> {busy ? "Writing…" : listing.short_description ? "Rewrite with AI" : "Write with AI"}</Button>
        </div>
        {TEXT_FIELDS.map(([k, label, rows]) => (
          <div key={k}>
            <Label>{label}</Label>
            {rows === 1 ? (
              <Input value={listing[k] || ""} onChange={(e) => setL(k, e.target.value)} className="mt-2 bg-white" data-testid={`listing-${k}-input`} />
            ) : (
              <Textarea rows={rows} value={listing[k] || ""} onChange={(e) => setL(k, e.target.value)} className="mt-2 bg-white" data-testid={`listing-${k}-input`} />
            )}
          </div>
        ))}
        {LIST_FIELDS.map((k) => (
          <div key={k}>
            <Label>{k.replace("_", " ")} (one per line)</Label>
            <Textarea rows={4} value={(listing[k] || []).join("\n")} onChange={(e) => setL(k, e.target.value.split("\n"))} className="mt-2 bg-white" data-testid={`listing-${k}-input`} />
          </div>
        ))}
      </div>
    </div>
  );
};
